import moment from 'moment'
export default {
  getMessage(field, args) {
    return field
  },
  validate(value, target) {
    var dtarget = moment(target[0], 'DD/MM/YYYY', true)
    var dvalue = moment(value, 'DD/MM/YYYY', true)
    if (!dvalue.isValid()) return true
    if (!dtarget.isValid()) return true
    return dvalue.isSameOrAfter(dtarget)
  }
}
